import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { deleteRight, getAllRights, createRight, editRight, getOneRight } from '../../api/axiosRights';
import { getAllBroadCategories } from '../../api/axiosBroadCategories';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';







const Rights = () => {
  const { broadCategories, setBroadCategories,rights, setRights, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()


  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  const [selectedBroadRight, setSelectedBroadRight] = useState("");
  
  const [right, setRight] = useState("");
  const [editedRight, setEditedRight] = useState("");
  


 

  const NewTitle = "All Rights";
  useEffect(() => {
    
    getAllRights(setRights, setFetcherror);
    getAllBroadCategories(setBroadCategories, setFetcherror);
    
  }, []);

  // Create New Array of Rights with BroadCategories.
  const newrightsArray = rights.map((item) => {
    const result = broadCategories.find((itemb) => itemb.id === item.broadcategory_id);
    return { ...item, broadcategory: result ? result.name : null };
  });
  

  const filteredRights = newrightsArray.filter((item) => item.name.toLowerCase().includes(globalFilter) || item.broadcategory.toLowerCase().includes(globalFilter))
  const filteredReversedRights = filteredRights.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setRights, setFetcherror, handleAllToasts) => {
    return () => {
      deleteRight(pkid, setRights, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this Right?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedRight(foundItem?.name);
   
  }



  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
          <SearchToolBar
              setAddItemDialogVisible={setAddItemDialogVisible}
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
              searchPlaceholder="Rights"
              createLabel="Right"
          />

        <DataTable
          value={filteredRights}
          showGridlines
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20]}
          emptyMessage="No rights found"
        >
                    <Column header="S/N" body={(rowData) => newrightsArray.indexOf(rowData)+1 } sortable> </Column>
                    <Column header="Broad Category" body={(rowData) => rowData.broadcategory } sortable></Column>
                    <Column header="Right"   body={(rowData) => rowData.name} sortable></Column>
                    <Column header="Actions" body={(rowData) => (  
                            <TableActions
                              id={rowData.id}
                              data={rights}
                              getItemtoEdit={getItemtoEdit}
                              setSelectedId={setSelectedId}
                              setEditDialogVisible={setEditDialogVisible}
                              setDeleteDialogVisible={ setDeleteDialogVisible}
                          />
                          )}>
                    </Column>
        </DataTable>

      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New Right" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createRight(right,selectedBroadRight?.id, setRight, setFetcherror, handleAllToasts, setRights);
                if (right ) { setAddItemDialogVisible(false); }
              }}>
                   <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">Broad Right </label>
                  <Dropdown
                   value={selectedBroadRight} onChange={(e) => setSelectedBroadRight(e.value)}
                   options={broadCategories} optionLabel="name"
                  placeholder="-- Select BroadCategory --" showClear className="w-full mb-4"
                  />
                

                  <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">Right </label>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Right Name"
                    value={right}
                    onChange={(e) => setRight(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setRight("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit Right" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editRight( selectedId, editedRight, setEditedRight,  setFetcherror, handleAllToasts, setRights);
                if (editedRight) { setEditDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter Right Name"
                    value={editedRight}
                    onChange={(e) => setEditedRight(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setRight("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setRights, setFetcherror, handleAllToasts)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default Rights


